import { queryOptions, useQuery } from "@tanstack/react-query";
import { getEnvironment } from "connect-api/enums/api/get-environment";

import { typedFetchNoImpersonate } from "~/api/typed-fetch";

import { toEnvironmentInfo } from "../../utils/to-environment-info";

interface UseGetEnvironmentInfoParams {
  enabled: boolean;
}

const queryKeys = {
  all: () => ["debug-info"] as const,
  getEnvironmentInfo: () => [...queryKeys.all(), "environment-info"],
};

const getEnvironmentInfoQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: queryKeys.getEnvironmentInfo(),
    queryFn: async ({ signal }) =>
      toEnvironmentInfo(await getEnvironment(typedFetchNoImpersonate, signal)),
    enabled,
    retry: false,
  });

const useEnvironmentInfo = (params: UseGetEnvironmentInfoParams) => {
  const query = useQuery(getEnvironmentInfoQueryOptions(params.enabled));

  return {
    environmentInfo: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
};

export { getEnvironmentInfoQueryOptions, useEnvironmentInfo };
export type { UseGetEnvironmentInfoParams };
